.wordmark {
  align-items: center;
  display: inline-flex;
  font-family: var(--font-family-heading);
  font-weight: 400;
  gap: 0.4em;
  line-height: 1;
  white-space: nowrap;
}

.wordmark b {
  font-weight: 700;
}

.mark {
  flex: none;
  height: 1.5em;
  width: 1.5em;
}

.dark {
  color: var(--color-cta);
}

.light {
  color: var(--color-link);
}

.ring_dark {
  stroke: var(--color-background);
}

.ring_light {
  stroke: var(--color-primary);
}

.line {
  stroke: var(--color-cta);
}

.star {
  fill: var(--color-accent);
}
